export default "__VITE_PUBLIC_ASSET__9641470a__"